<template>
  <div class="page-wrapper">    
    <Header></Header>
    <div class="main-container">
      <div class="main-focus" >
        <!--
        <el-image
            style="width:100%;height:100%;"
            :src="require('@/assets/img/banner-01.jpg')"
            fit="cover"
        />
        -->
      </div>
      <NewsBlock></NewsBlock>
      <LifetimeBlock></LifetimeBlock>
      <MoviesBlock></MoviesBlock>
      <HonorBlock></HonorBlock>
      <WritingsBlock></WritingsBlock>
      <MemoryBlock></MemoryBlock>
      <ShowroomBlock></ShowroomBlock>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  import NewsBlock from "@/components/blocks/newsblock";
  import LifetimeBlock from "@/components/blocks/lifetimeblock";
  import MoviesBlock from "@/components/blocks/moviesblock";
  import HonorBlock from "@/components/blocks/honorblock";
  import WritingsBlock from "@/components/blocks/writingsblock";
  import MemoryBlock from "@/components/blocks/memoryblock";
  import ShowroomBlock from "@/components/blocks/showroomblock";
  export default {
    components: { Header, NewsBlock, LifetimeBlock, MoviesBlock, HonorBlock, WritingsBlock, MemoryBlock, ShowroomBlock, Footer},
    props: {},
    data() {
        return {
          focusBoxHeight: this.getFocusImageHeight(),
          timer: false,
        };
      },
    methods: {
      getFocusImageHeight(){
        let h = document.body.clientHeight;
        if(h > 900){
          h = 900;
        }
        return h;
      }
    },
    created() {
      document.title = "首页 | 纪念王选官网";
      this.$nextTick(()=>{
        window.scroll(0, 0);
      });      
    },
    mounted() {
      let _this = this;
      window.onresize = () => {
        return (() => {
           window.screenHeight = document.body.clientHeight;
           _this.focusBoxHeight = _this.getFocusImageHeight();
        })()
      }    
    },
    watch:{
      focusBoxHeight:function(val, oldVal){
        if(!this.timer){
          this.focusBoxHeight = val;
          this.timer = true;
          let _this = this;
          setTimeout(function() {            
            _this.timer = false;            
          }, 400);
        }
      }
    }
  };
</script>

<style scoped>

.main-focus{
  width: 100%;
  background: url('~@/assets/img/banner-01.jpg') no-repeat;
  background-position: center center;
  background-size: cover;
}

/*焦点图自适应屏幕*/
@media screen and (max-width:502px){
    .main-focus{
        height: 220px;
    }
}

@media screen and (min-width:503px){
    .main-focus{
        height: calc((814/1860)*100vw);
    }
}

@media screen and (min-width:1143px){
    .main-focus{
        height: 500px;
    }
}
@media screen and (min-width:1499px){
    .main-focus{
        height: calc((814/2440)*100vw);
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/homepage.vue